import { CameraView } from "dynamsoft-camera-enhancer";

CameraView.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-camera-enhancer@4.0.0/dist/";
